import { Component, HostListener, OnInit} from '@angular/core';
import { RouterModule } from '@angular/router';
import { faLinkedin, faXing } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.less'],
  imports: [RouterModule]
})
export class NavComponent implements OnInit {

  faLinkedin = faLinkedin;
  faXing = faXing;
  preVScrollpos = window.scrollY;
  nav: any;

  constructor() {
    
   }

  ngOnInit(): void {
    const element = document.getElementById("nav")!;
    this.nav = element;
    this.nav.style.top = "0";
  }

@HostListener('window:scroll')

onScroll() {
  if(document.body.clientWidth < 534){
    var currentScrollPos = window.scrollY;
    if(this.preVScrollpos > currentScrollPos) {
      this.nav.style.top = "0";
    } else {
      setTimeout(()=>{
        this.nav.style.top = "-55px";
      }, 500)
      
    }

    this.preVScrollpos = currentScrollPos;
  } else {
    this.nav.style.top = "0";
    var currentScrollPos = window.scrollY;
  }
  if(currentScrollPos < 470){
    //this.nav.style.backgroundColor ="transparent";
    //document.documentElement.style.setProperty('--font-color', 'white')
  } else {
    //this.nav.style.backgroundColor = "white";
    //document.documentElement.style.setProperty('--font-color', 'black')

  }
}

@HostListener('window:resize', ['$event'])
onResize(event: any) {
  if(document.body.clientWidth > 534){
    this.nav.style.top = "0";
  }
}

}
